import styled from 'styled-components'

export const ModalBodyWrapper = styled.div`
  padding: 20px 10px;
  max-height: 60vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 450px;
`
